import { FlexBox } from '@airship-platform/jam-web/components';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { type DurationBillingItem } from '../../data-access';

const BILLING_FREQUENCY_LABELS: Record<
  DurationBillingItem['billingFrequency'],
  string
> = {
  ONE_TIME: 'one-time',
  MONTHLY: 'monthly',
  EVERY_OTHER_MONTH: 'every other month',
  QUARTERLY: 'quarterly',
  BI_ANNUAL: 'bi-annually',
  ANNUAL: 'annually',
};

const formatDurationLabel = (item: DurationBillingItem) => {
  const billingLabel = BILLING_FREQUENCY_LABELS[item.billingFrequency];
  return item.duration !== null && item.duration !== undefined
    ? `${item.duration} months, billed ${billingLabel}`
    : `Billed ${billingLabel}`;
};

interface DurationBillingSelectProps {
  items: DurationBillingItem[];
  selectedDurationBillingId: string;
  isDisabled?: boolean;
  onChange: (item: DurationBillingItem) => void;
}

const DurationBillingSelect: React.FC<DurationBillingSelectProps> = ({
  items,
  selectedDurationBillingId,
  isDisabled,
  onChange,
}) => {
  if (!items.length) {
    return null;
  }

  const activeItems = items.filter((item) => item.active !== false);
  if (!activeItems.length) {
    return null;
  }

  return (
    <FlexBox flexDirection="column" gap={1}>
      <Typography variant="subtitle2">
        Select membership duration and billing
      </Typography>
      <TextField
        select
        value={selectedDurationBillingId}
        onChange={(e) => {
          const selected = activeItems.find(
            (item) => item.durationBillingId === e.target.value
          );
          if (selected) {
            onChange(selected);
          }
        }}
        disabled={isDisabled}
        size="small"
      >
        {activeItems.map((item) => (
          <MenuItem key={item.durationBillingId} value={item.durationBillingId}>
            {formatDurationLabel(item)}
          </MenuItem>
        ))}
      </TextField>
    </FlexBox>
  );
};

export default DurationBillingSelect;
